const GTM_DATA_STORAGE_KEY = 'gtmData';
const GTM_DATA_TTL = 60 * 60 * 1000;
const ANALYTICS_CONSENT_GRANTED_EVENT = 'analytics-consent-granted';

const hasGrantedAnalyticsConsent = () => {
  if (!Array.isArray(window.dataLayer)) {
    return false;
  }

  for (let index = window.dataLayer.length - 1; index >= 0; index -= 1) {
    const entry = window.dataLayer[index];

    if (
      entry
      && (entry.event === 'consent_default' || entry.event === 'consent_update')
      && Object.prototype.hasOwnProperty.call(entry, 'analytics_storage')
    ) {
      return entry.analytics_storage === 'granted';
    }
  }

  return false;
};

const pushGtmEvent = (bindingValue) => {
  const data = bindingValue.data || {};
  const utmData = JSON.parse(sessionStorage.getItem('utm_params'));

  if (utmData) {
    data.utmParams = utmData;
  }

  window.dataLayer.push({
    event: bindingValue.event,
    ...data
  });
};

export const getStoredGtmData = () => {
  const storedData = localStorage.getItem(GTM_DATA_STORAGE_KEY);

  if (!storedData) {
    return {};
  }

  try {
    const data = JSON.parse(storedData);
    const hasStoredValue = Object.prototype.hasOwnProperty.call(data, 'value');

    if (!hasStoredValue || !Number.isFinite(data.expiresAt) || Date.now() > data.expiresAt) {
      localStorage.removeItem(GTM_DATA_STORAGE_KEY);
      return {};
    }

    return data.value || {};
  } catch (error) {
    localStorage.removeItem(GTM_DATA_STORAGE_KEY);
    return {};
  }
};

export const gtmHelper = {
  mounted(el, binding) {
    if (binding.value) {
      if (!window.dataLayer) {
        window.dataLayer = window.dataLayer || [];
      }

      const data = binding.value.data || {};
      localStorage.setItem(GTM_DATA_STORAGE_KEY, JSON.stringify({
        value: data,
        expiresAt: Date.now() + GTM_DATA_TTL,
      }));

      if (hasGrantedAnalyticsConsent()) {
        pushGtmEvent(binding.value);
        return;
      }

      let hasPushed = false;

      const onConsentGranted = () => {
        if (hasPushed) {
          return;
        }

        hasPushed = true;
        pushGtmEvent(binding.value);
        delete el.__gtmConsentGrantedListener;
      };

      el.__gtmConsentGrantedListener = onConsentGranted;
      window.addEventListener(ANALYTICS_CONSENT_GRANTED_EVENT, onConsentGranted, { once: true });

      if (hasGrantedAnalyticsConsent()) {
        window.removeEventListener(ANALYTICS_CONSENT_GRANTED_EVENT, onConsentGranted);
        onConsentGranted();
      }
    }
  },
  unmounted(el) {
    if (el.__gtmConsentGrantedListener) {
      window.removeEventListener(ANALYTICS_CONSENT_GRANTED_EVENT, el.__gtmConsentGrantedListener);
      delete el.__gtmConsentGrantedListener;
    }
  },
};
